import React, { FormEvent } from 'react';

import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react';
import { apiStatusStore } from '../../../../../shared/stores/apiStatusStore';
import { updateUserInfo } from '../../../../../shared/utils/userInfoUtils';
import { goTo } from '../../../../../shared/utils/angularUtils';
import { entityPaymentService } from '../../../../../shared/services/entity/entityPaymentService';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { ENTITY_PROFILE_TAB_NAME } from '../../../../../shared/constants/tabNames/ENTITY_PROFILE_TAB_NAME';
import { pathQueryParams } from '../../../../../shared/constants/pathQueryParams';

type StripeSaveCardFormProps = {
  formId: string;
};

const StripeSaveCardForm = observer(({ formId }: StripeSaveCardFormProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const { getEntityId } = loggedInUserDataStore;

  const entityId = getEntityId();

  const savePaymentMethod = async () => {
    if (!stripe || !elements) {
      throw new Error('Stripe or Elements not loaded');
    }

    await elements.submit();

    const { error } = await stripe.confirmSetup({
      elements,
      redirect: 'if_required',
    });

    if (error) {
      throw new Error(error.message);
    }
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    apiStatusStore.loadingStart(true);

    try {
      await savePaymentMethod();
      const { selfBillingEntityPaymentStatus } =
        await entityPaymentService.getSelfBillingPaymentStatus(entityId);

      updateUserInfo({
        entity: { selfBillingEntityPaymentStatus },
      });
      goTo('/entity-profile', {
        replaceHistory: true,
        params: {
          [pathQueryParams.initialTabName]: ENTITY_PROFILE_TAB_NAME.PAYMENT,
        },
      });
    } catch (error: any) {
      apiStatusStore.addErrorMessage(error.message);
    } finally {
      apiStatusStore.loadingEnd(true);
    }
  };

  return (
    <form id={formId} onSubmit={handleSubmit}>
      <PaymentElement
        id="card-info-box" // A&A test id
        options={{
          wallets: { applePay: 'never', googlePay: 'never' },
        }}
      />
    </form>
  );
});

export { StripeSaveCardForm };
